// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chatView[data-v-e0c4a73c]{height:100%;display:flex;flex-direction:column;flex-grow:1}\n", ""]);
// Exports
module.exports = exports;
